import {h, Fragment} from "preact"
import { useEffect } from 'preact/hooks'

export default () => {
    useEffect(() => {
        nostojs((api) => {
            api.createRecommendationRequest().setElements(['nosto-search-rec']).loadRecommendations()
        })
    }, [])

    useEffect(() => {
        const header = document.querySelector('#shopify-section-header')
        const searchHeader = document.querySelector('.header__search')
        const nsOverlay = document.querySelector('.ns-overlay')


        if (searchHeader && searchHeader.classList.contains('active--search') && !nsOverlay) {
            // Overlay element
            const nostoOverlay = document.createElement('div')
            nostoOverlay.className = 'ns-overlay'
            nostoOverlay.style.position = 'fixed'
            nostoOverlay.style.display = 'block'
            nostoOverlay.style.backgroundColor = '#406ac0cc'
            nostoOverlay.style.webkitBackdropFilter = 'blur(4px)'
            nostoOverlay.style.backdropFilter = 'blur(4px)'
            nostoOverlay.style.height = '100vh'
            nostoOverlay.style.width = '100vw'
            nostoOverlay.style.webkitTransition = 'opacity .25s ease'
            nostoOverlay.style.transition = 'opacity .25s ease'
            nostoOverlay.style.pointerEvents = 'none'
            nostoOverlay.style.zIndex = '12'
            nostoOverlay.style.opacity = '1'

            // Insert nostoOverlay before header
            if (header) {
                header.parentNode.insertBefore(nostoOverlay, header)
            }

            // Create a MutationObserver to watch for changes in searchHeader's class attribute
            const observer = new MutationObserver(() => {
                if (searchHeader.classList.contains('active--search')) {
                    nostoOverlay.style.opacity = '1'
                } else {
                    nostoOverlay.style.opacity = '0'
                }
            })

            observer.observe(searchHeader, { attributes: true, attributeFilter: ['class'] })

            return () => {
                observer.disconnect()
            }
        }
    }, [])

    return (
        <>
            <div class="ns-autocomplete ns-history ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto">
                <div class="ns-w-100 ns-mt-sm-auto">
                    <div class="nosto_element" id="nosto-search-rec"></div>
                </div>
            </div>
        </>
    )
}
